import type { ILayoutId } from '@/core/features/a-dynamic-page/dynamic-page-pacts/dynamic-page-type';
import type { DynamicPageProps } from '@/core/features/a-dynamic-page/dynamic-page-types';

import { ErrorPage } from '@/core/features';
import useAppBridgeInit from '@/core/features/wireframe/use-app-bridge-init';
import MobileLayout from '@/features/page-layouts/mobile/mobile-layout';

export default function MobileLayoutSwitch(props: DynamicPageProps) {
    const layoutId: ILayoutId | null = props.meta?.layoutId ?? null;
    useAppBridgeInit();

    switch (layoutId) {
        case 'App_Error_Page': {
            return (
                <ErrorPage
                    detail={'Layout Mobile'}
                    isPageLoading={props.isPageLoading}
                    statusCode={500}
                />
            );
        }
        default: {
            return <MobileLayout {...props} />;
        }
    }
}
